import { Box, Stack, Typography } from '@mui/material';
import { Row } from '../../interfaces';
import { HeaderCells } from '../../types/ui';
import {
  AutomationActionHandlers,
  AutomationListItem,
} from '../../types/marketing/automations';
import DropdownMenu from '../../components/global/DropdownMenu';
import AutomationBadge from '../../components/marketing/AutomationBadge';
import { pluralize } from '../global/helper';

export const headerCells = [
  { id: 'automation', label: 'Automation' },
  { id: 'status', label: 'Status' },
  { id: 'reached', label: 'Customers Reached' },
  { id: 'action', label: '' },
] as const satisfies HeaderCells;

export function getAutomationRowElementId(automationId: string) {
  return `automation-row-${automationId}`;
}

export function createRow(
  automation: AutomationListItem,
  {
    handlers,
    disableActions,
    isHighlighted,
  }: {
    handlers: AutomationActionHandlers;
    disableActions?: boolean;
    isHighlighted?: boolean;
  },
): Row {
  const isActive = automation.status === 'ACTIVE';

  return {
    rowId: automation.id,
    cells: [
      <Box
        id={getAutomationRowElementId(automation.id)}
        sx={{
          mx: -1,
          px: 1,
          py: 0.5,
          borderRadius: '4px',
          transition: 'background-color 0.6s',
          bgcolor: isHighlighted ? 'accent.main' : 'transparent',
          scrollMarginTop: '120px',
        }}>
        <Stack gap={0.25} maxWidth="400px" overflow="hidden">
          <Typography variant="h5" noWrap>
            {automation.name}
          </Typography>
          <Typography variant="body2">{automation.triggerSummary}</Typography>
        </Stack>
      </Box>,
      <AutomationBadge status={automation.status} />,
      <Typography variant="body2">
        {automation.customersReached === null
          ? ''
          : `${automation.customersReached} ${pluralize(
              'Customer',
              automation.customersReached,
            )}`}
      </Typography>,
      <DropdownMenu
        options={[
          isActive
            ? {
                label: 'Pause',
                action: () => handlers.onPauseAutomation(automation.id),
              }
            : {
                label: 'Resume',
                action: () => handlers.onResumeAutomation(automation.id),
              },
          {
            label: 'Delete',
            action: () => handlers.onDeleteAutomation(automation.id),
          },
        ]}
        disabled={disableActions}
        center
      />,
    ],
  };
}
